import { render, staticRenderFns } from "./TicketChatLogList.vue?vue&type=template&id=570dbb79&"
import script from "./TicketChatLogList.vue?vue&type=script&lang=js&"
export * from "./TicketChatLogList.vue?vue&type=script&lang=js&"
import style0 from "./TicketChatLogList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports